module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_8_m.324716af9ff5d99443371f727e73ab58.png";